/* @flow */
import * as React from 'react';

import Text from 'components/Text';

type Props = {
  children: number,
};

export default function AdminStatisticsChartTooltipValue({ children, ...others }: Props) {
  return (
    <Text {...others} color="pitch" size="xlarge">
      {children.toLocaleString()}
    </Text>
  );
}
